import { render, staticRenderFns } from "./Shortcut.vue?vue&type=template&id=295a7968&scoped=true"
import script from "./Shortcut.vue?vue&type=script&lang=js"
export * from "./Shortcut.vue?vue&type=script&lang=js"
import style0 from "./Shortcut.vue?vue&type=style&index=0&id=295a7968&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295a7968",
  null
  
)

export default component.exports